export default __webpack_public_path__ + "static/media/product5.1dcde060.JPG";